import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { PRIEST_TOKEN, plogin, pme } from "./api";

const Ctx = createContext(null);
export const usePriest = () => useContext(Ctx);

export function PriestProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem(PRIEST_TOKEN)) {
        try { setUser(await pme()); } catch { localStorage.removeItem(PRIEST_TOKEN); }
      }
      setReady(true);
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const d = await plogin(email, password);
    localStorage.setItem(PRIEST_TOKEN, d.access_token);
    setUser(d.user);
    return d.user;
  }, []);

  const demoLogin = useCallback(() => login("priest@demo.in", "priest123"), [login]);

  const logout = useCallback(() => {
    localStorage.removeItem(PRIEST_TOKEN);
    setUser(null);
    window.location.href = "/priest/login";
  }, []);

  return <Ctx.Provider value={{ user, ready, login, demoLogin, logout }}>{children}</Ctx.Provider>;
}
